import React from 'react';

export default ({ record, source }) => (
  <div
    style={{
        fontFamily: 'monospace',
        background: '#eee',
        padding: '1em',
      }}
  >
    {JSON.stringify(record[source], null, 2)}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/General/DatagridJSONField.jsx